import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import DxDiagnosisExplanation from '@src/features/company/dx-diagnosis/DxDiagnosisExplanation';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';

function CompanyDxDiagnosisExplanation() {
  return (
    <CompanyGuard
      canRoles={[COMPANY_ROLE.ADMIN]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <CompanyNoMenusLayout showLogo={true}>
        <CommonHelmet />
        <DxDiagnosisExplanation />
      </CompanyNoMenusLayout>
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisExplanation;
